"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitLineItemsSizes = void 0;
const commerce_tools_custom_fields_1 = require("./commerce-tools-custom-fields");
function splitLineItemsSizes(lineItems) {
    return lineItems.flatMap((lineItem) => {
        const garments = getGarments(lineItem);
        if (!garments)
            return lineItem;
        return garments.map((garment) => {
            const [sizeRunId, quantity] = Object.entries(garment)[0];
            return { ...lineItem, quantity, sizeRunId };
        });
    });
}
exports.splitLineItemsSizes = splitLineItemsSizes;
function getGarments(lineItem) {
    const config = (0, commerce_tools_custom_fields_1.parseCustomField)(lineItem, "productConfig");
    const sizeRun = config?.["sizeRun"];
    const garmentItems = Object.entries(sizeRun ?? {})
        .filter((item) => item[1] !== 0)
        ?.map(([key, value]) => ({ [key]: value }));
    const priceDetails = (0, commerce_tools_custom_fields_1.parseCustomField)(lineItem, "priceDetails");
    if (priceDetails?.details?.calculator === "unit" && garmentItems.length) {
        return garmentItems;
    }
    return null;
}
